import { css } from '@emotion/react'

const GlobalStyles = css`
  html {
    font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
      Roboto;
    box-sizing: border-box;
    font-size: 62.5%;
  }
  body,
  html {
    width: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden;
  }
  body {
    font-size: 14px;
    font-size: 1.4rem;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  * {
    margin: 0;
    padding: 0;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  #gatsby-focus-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-contents: flex-start;
  }
`
export default GlobalStyles
